import axios from 'axios';

var axiosFileApi = axios.create();
 //   {baseURL: "http://localhost:83"}
//axiosFileApi.defaults.headers.common['X-AUTH-TOKEN' ] = 'gduhdhuwd76ck28';

export default axiosFileApi;
